import type { IHeaderParams, ColDef } from 'ag-grid-community';
import { ColumnChooser } from './ColumnChooser';

interface Params extends IHeaderParams {
  /** The tabular columns the in-grid chooser controls (supplied via headerComponentParams). */
  columnDefs: ColDef[];
  /** Persist callback after a chooser change (supplied via headerComponentParams). */
  onColumnsChange: () => void;
}

/**
 * Header of the grid view's leading pinned selection column: just the in-grid column
 * chooser, centered. Select-all lives in the toolbar (SelectAllButtons), so there's no
 * checkbox here — it would be redundant. Icon matches Angular's grid chooser (fa-sliders-h).
 */
export function GridSelectionHeader(params: Params) {
  return (
    <div className="grid-selection-header">
      <ColumnChooser
        columnApi={params.columnApi}
        columnDefs={params.columnDefs}
        onChange={params.onColumnsChange}
        buttonClassName="btn btn-link btn-xs grid-columns-trigger"
        label={<i className="fas fa-sliders-h fa-lg" />}
      />
    </div>
  );
}
